// WhatsAppButton.js
import React from 'react';
import './WhatsAppButton.css';

function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/918186085043"
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src="/images/whatsapp.png" alt="WhatsApp" />
    </a>
  );
}

export default WhatsAppButton;
